import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { SopDetail } from '../Models/SopDetail';
import { TranslationKeys } from 'ph-bhp-localization';
import { SeriesVisualArgs } from '@progress/kendo-angular-charts';
import { drawing, geometry } from '@progress/kendo-drawing';

@Component({
  selector: 'lib-ph-bhp-pdf-sop-report',
  templateUrl: './ph-bhp-pdf-sop-report.component.html',
  styleUrls: ['./ph-bhp-pdf-sop-report.component.css']
})
export class PhBhpPdfSopReportComponent implements OnInit {
  public repeatHeaders = true;
  printChart = false;
  showsecondfilter
  predefinedComments
  frequencyDistribution;
  processCompliance;
  subStepProcessCompliance;
  frequencyDistributionFilter: any;
  processComplianceFilter: any;
  subStepProcessComplianceFilter: any;
  predefinedCommentsFilter: any;
  sopDetail: SopDetail[];
  frequencySopTittle: string;
  processComplianceSopTittle: string;
  subStepProcessComplianceSopTittle: string;
  predefinedCommentsSopTittle: string;
  gridData;
  childChartCountProcess: Array<any> = [];
  childChartCountSubstep: Array<any> = [];
  childChartCountFrequency: Array<any> = [];
  childChartCountComments: Array<any> = [];

  processComplianceNoDataFound: boolean = false;
  frequencyDistributionNoDataFound: boolean = false;
  subProcessNoDataFound: boolean = false;
  sopCommentsNoDataFound: boolean = false;
  overallComplianceNoDataFound: boolean = false;
  fiveMomentsNoDataFound: boolean = false;
  asepticProceduresNoDataFound: boolean = false;
  observeCommentsNoDataFound: boolean = false;

  roleId;
  packageID;
  isObserve: boolean;
  isSOP: boolean;
  isCheck: boolean;

  @ViewChildren('chartListProcess') chartListProcess
  @ViewChildren('chartListSubstep') chartListSubstep
  @ViewChildren('chartListComments') chartListComments
  @ViewChildren('chartListFrequency') chartListFrequency
  @ViewChild('filterDetails') filterDetails;
  @ViewChild('frequencyChart') frequencyChart;
  @ViewChild('processComplianceChart') processComplianceChart;
  @ViewChild('subStepProcessChart') subStepProcessChart;
  @ViewChild('predefinedCommentsChart') predefinedCommentsChart;
  @ViewChild('pdf') pdf;
  @ViewChild('processComplianceDetails') processComplianceDetails;
  @ViewChild('frequencyDistributionDetails') frequencyDistributionDetails;
  @ViewChild('subStepComplianceDetails') subStepComplianceDetails;
  @ViewChild('commentsDetails') commentsDetails;


  chartOptionsSubstep;
  chartOptionsProcess;
  chartOptionsFrequency;
  chartOptionsComments;
  fixedFilterHight = 70


  // Observe
  @ViewChild('overallCompliance') overallCompliance;
  @ViewChild('overallComplianceDetails') overallComplianceDetails;
  @ViewChildren('chartListOverallCompliance') chartListOverallCompliance;
  childChartCountOverallCompliance: Array<any> = [];
  chartOverallCompliance;
  overallComplianceFilter;

  @ViewChild('fiveMoments') fiveMoments;
  @ViewChild('fiveMomentsDetails') fiveMomentsDetails;
  @ViewChildren('chartListFiveMoments') chartListFiveMoments;
  childChartCountFiveMoments: Array<any> = [];
  chartFiveMoments;
  fiveMomentsFilter;

  @ViewChild('asepticProcedures') asepticProcedures;
  @ViewChild('asepticProceduresDetails') asepticProceduresDetails;
  @ViewChildren('chartListAsepticProcedures') chartListAsepticProcedures;
  childChartCountAsepticProcedures: Array<any> = [];
  chartAsepticProcedures;
  asepticProceduresFilter;

  @ViewChild('observeComments') observeComments;
  @ViewChild('observeCommentsDetails') observeCommentsDetails;
  @ViewChildren('chartListObserveComments') chartListObserveComments;
  childChartCountObserveComments: Array<any> = [];
  chartObserveComments;
  observeCommentsFilter;
  logoSrc = 'assets/img/app-logo.svg';

  translationKeys: typeof TranslationKeys = TranslationKeys;
  maxFilters = 0;

  constructor(
    public config: AppConfig,
    private layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
    this.loadLogo();
  }

  ngAfterViewInit() {
    this.roleId = this.config.userData ? this.config.userData.roleName.roleId : '';
    this.packageID = this.layoutService.packageID;
    this.checkEvalMode();

    this.chartListSubstep.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        list.chartOptions = this.childChartCountSubstep[index].chartOptions
        list.chartOptions.categoryAxis.categories = this.childChartCountSubstep[index].categories
        list.chartOptions.series = this.childChartCountSubstep[index].series;
        list.chartDatamani();
        list.chart.element.nativeElement.style.height = "400px";
      })
    });

    this.chartListProcess.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        list.chartOptions = this.childChartCountProcess[index].chartOptions;
        list.chartOptions.categoryAxis.categories = this.childChartCountProcess[index].categories;
        list.chartOptions.series = this.childChartCountProcess[index].series;
        list.chartDatamani();
        list.chart.element.nativeElement.style.height = "400px";
      })
    });

    this.chartListFrequency.changes.subscribe((newList2) => {
      newList2.forEach((list, index) => {
        list.chartOptions = this.childChartCountFrequency[index].chartOptions
        list.chartOptions.categoryAxis.categories = this.childChartCountFrequency[index].categories
        list.chartOptions.series = this.childChartCountFrequency[index].series;
        list.chartDatamani();
        list.chart.element.nativeElement.style.height = "400px";
      })
    });

    this.chartListComments.changes.subscribe((newList3) => {
      newList3.forEach((list, index) => {
        list.chartOptions = this.childChartCountComments[index].chartOptions
        list.chartOptions.categoryAxis.categories = this.childChartCountComments[index].categories
        list.chartOptions.series = this.childChartCountComments[index].series;
        list.chartDatamani();
        list.chart.element.nativeElement.style.height = "400px";

      })
    });
    // Observe
    this.chartListOverallCompliance.changes.subscribe((newList4) => {
      newList4.forEach((list, index) => {
        if (this.childChartCountOverallCompliance.length > 0) {
          list.chartOptions = this.childChartCountOverallCompliance[index].chartOptions
          list.chartOptions.categoryAxis.categories = this.childChartCountOverallCompliance[index].categories
          list.chartOptions.series = this.childChartCountOverallCompliance[index].series;
          list.chartDatamani();
          list.chart.element.nativeElement.style.height = "400px";
        }
      })
    });

    this.chartListFiveMoments.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        if (this.childChartCountFiveMoments.length > 0) {
          list.chartOptions = this.childChartCountFiveMoments[index].chartOptions;
          list.chartOptions.categoryAxis.categories = this.childChartCountFiveMoments[index].categories;
          list.chartOptions.series = this.childChartCountFiveMoments[index].series;
          list.chartDatamani();
          list.chart.element.nativeElement.style.height = "400px";
        }
      })
    });

    this.chartListAsepticProcedures.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        if (this.childChartCountAsepticProcedures.length > 0) {
          list.chartOptions = this.childChartCountAsepticProcedures[index].chartOptions;
          list.chartOptions.categoryAxis.categories = this.childChartCountAsepticProcedures[index].categories;
          list.chartOptions.series = this.childChartCountAsepticProcedures[index].series;
          list.chartDatamani();
          list.chart.element.nativeElement.style.height = "400px";
        }
      })
    });

    this.chartListObserveComments.changes.subscribe((newList) => {
      newList.forEach((list, index) => {
        if (this.childChartCountObserveComments.length > 0) {
          list.chartOptions = this.childChartCountObserveComments[index].chartOptions;
          list.chartOptions.categoryAxis.categories = this.childChartCountObserveComments[index].categories;
          list.chartOptions.series = this.childChartCountObserveComments[index].series;
          list.chartDatamani();
          list.chart.element.nativeElement.style.height = "700px";
        }
      })
    });


  }

  breakChartSubstep() {
    var chartOptions = JSON.parse(JSON.stringify(this.subStepProcessChart.chartOptions));
    var offsetHeight = this.frequencyDistributionDetails.nativeElement.offsetHeight;
    var freePage = 700 - (offsetHeight % 700)
    var ChartHight = freePage - this.fixedFilterHight; //fixedFilterHight -> heading
    var newPage = false;
    if (freePage < 350) {
      this.frequencyDistributionDetails.nativeElement.style.height = (offsetHeight + (offsetHeight % 700)) + "px";
      newPage = true;
    }

    var barLenth = 10;
    if (newPage == true) {
      ChartHight = 700
    } else if (ChartHight >= 550) {
      barLenth = 10
    } else if (ChartHight >= 400) {
      barLenth = 8
    } else {
      barLenth = 4
    }
    this.subStepProcessChart.chart.element.nativeElement.style.height = ChartHight + "px"
    if (chartOptions.series[0].data.length > barLenth) {
      var categoryAxis = chartOptions.categoryAxis.categories;
      var newCategoryAxis = categoryAxis.splice(0, barLenth);
      this.subStepProcessChart.chartOptions.categoryAxis.categories = newCategoryAxis;
      chartOptions.series.forEach((element, index) => {
        var newArray = element.data.splice(0, barLenth);
        this.subStepProcessChart.chartOptions.series[index].data = newArray;
      });
      while (chartOptions.series[0].data.length) {
        if (chartOptions.series[0].data.length > 10) {
          var tempData = chartOptions.series;
          var categoryAxis = chartOptions.categoryAxis.categories;
          var newCategoryAxis = categoryAxis.splice(0, 10);
          chartOptions.series.forEach((element, index) => {
            var newArray = element.data.splice(0, 10);
            tempData[index].data = newArray;
          });
          this.childChartCountSubstep.push({
            chartOptions: chartOptions,
            categories: newCategoryAxis,
            series: tempData
          })
        } else {
          this.childChartCountSubstep.push({
            chartOptions: chartOptions,
            categories: chartOptions.categoryAxis.categories,
            series: chartOptions.series
          })
          break;
        }
      }
    } else {
      this.subStepProcessChart.chart.element.nativeElement.style.height = "400px"
    }
  }

  breakChartProcess() {
    const chartOptions = JSON.parse(JSON.stringify(this.processComplianceChart.chartOptions));
    const chartHeight = 400;
    const elementsPerChart = 5;
    this.processComplianceChart.chart.element.nativeElement.style.height = `${chartHeight}px`;

    if (chartOptions.series[0].data.length > elementsPerChart) {
      const initialCategoryAxis = chartOptions.categoryAxis.categories.splice(0, elementsPerChart);
      this.processComplianceChart.chartOptions.categoryAxis.categories = initialCategoryAxis;
      chartOptions.series.forEach((element, index) => {
        const initialDataArray = element.data.splice(0, elementsPerChart);
        this.processComplianceChart.chartOptions.series[index].data = initialDataArray;
      });

      while (chartOptions.series[0].data.length) {
        const newCategoryAxis = chartOptions.categoryAxis.categories.splice(0, elementsPerChart);
        const newSeriesData = chartOptions.series.map((element) => {
          return { ...element, data: element.data.splice(0, elementsPerChart) };
        });

        this.childChartCountProcess.push({
          chartOptions: JSON.parse(JSON.stringify(chartOptions)),
          categories: newCategoryAxis,
          series: newSeriesData
        });

        if (chartOptions.series[0].data.length <= elementsPerChart) {
          this.childChartCountProcess.push({
            chartOptions: JSON.parse(JSON.stringify(chartOptions)),
            categories: chartOptions.categoryAxis.categories,
            series: chartOptions.series
          });
          break;
        }
      }
    }
  }

  breakChartCompliance(complianceChart, prevComplianceDetails, childChartCount, newPage = false) {
    if (prevComplianceDetails) {
      var chartOptions = JSON.parse(JSON.stringify(complianceChart.chartOptions));
      var offsetHeight = prevComplianceDetails.nativeElement.offsetHeight;
      var freePage = 700 - (offsetHeight % 700)
      var ChartHight = freePage - this.fixedFilterHight;//fixedFilterHight -> heading
      if (freePage < 350 || newPage) {
        prevComplianceDetails.nativeElement.style.height = (offsetHeight + (offsetHeight % 700)) + "px";
        newPage = true;
      }
      var barLenth = 10

      if (newPage == true) {
        ChartHight = 700
      } else if (ChartHight >= 550) {
        barLenth = 10
      } else if (ChartHight >= 400) {
        barLenth = 8
      } else {
        barLenth = 4
      }
      complianceChart.chart.element.nativeElement.style.height = ChartHight + "px"

      if (chartOptions.series[0].data.length > barLenth) {
        var categoryAxis = chartOptions.categoryAxis.categories;
        var newCategoryAxis = categoryAxis.splice(0, barLenth);
        complianceChart.chartOptions.categoryAxis.categories = newCategoryAxis;
        chartOptions.series.forEach((element, index) => {
          var newArray = element.data.splice(0, barLenth);
          complianceChart.chartOptions.series[index].data = newArray;
        });

        while (chartOptions.series[0].data.length) {

          if (chartOptions.series[0].data.length > 10) {
            var tempData = chartOptions.series;
            var categoryAxis = chartOptions.categoryAxis.categories;
            var newCategoryAxis = categoryAxis.splice(0, 10);
            chartOptions.series.forEach((element, index) => {
              var newArray = element.data.splice(0, 10);
              tempData[index].data = newArray;
            });

            childChartCount.push({
              chartOptions: chartOptions,
              categories: newCategoryAxis,
              series: tempData
            })
          } else {

            childChartCount.push({
              chartOptions: chartOptions,
              categories: chartOptions.categoryAxis.categories,
              series: chartOptions.series
            })
            break;
          }
        }
      } else {
        complianceChart.chart.element.nativeElement.style.height = "400px"
      }
    }
  }

  breakChartComplianceMultiFilter(complianceChart, prevComplianceDetails, childChartCount, chartHeight, newPage = false) {
    if (prevComplianceDetails) {
      var offsetHeight = prevComplianceDetails.nativeElement.offsetHeight;
      var freePage = 700 - (offsetHeight % 700)
      if (freePage < 350 || newPage) {
        prevComplianceDetails.nativeElement.style.height = (offsetHeight + (offsetHeight % 700)) + "px";
        newPage = true;
      }
    }
    const chartOptions = JSON.parse(JSON.stringify(complianceChart.chartOptions));
    const elementsPerChart = 1;
    const complianceChartHeight = 250;
    complianceChart.chart.element.nativeElement.style.height = `${complianceChartHeight}px`;

    if (chartOptions.series[0].data.length > elementsPerChart) {
      const initialCategoryAxis = chartOptions.categoryAxis.categories.splice(0, elementsPerChart);
      complianceChart.chartOptions.categoryAxis.categories = initialCategoryAxis;
      chartOptions.series.forEach((element, index) => {
        const initialDataArray = element.data.splice(0, elementsPerChart);
        complianceChart.chartOptions.series[index].data = initialDataArray;
      });

      while (chartOptions.series[0].data.length) {
        const newCategoryAxis = chartOptions.categoryAxis.categories.splice(0, elementsPerChart);
        const newSeriesData = chartOptions.series.map((element) => {
          return { ...element, data: element.data.splice(0, elementsPerChart) };
        });

        childChartCount.push({
          chartOptions: JSON.parse(JSON.stringify(chartOptions)),
          categories: newCategoryAxis,
          series: newSeriesData
        });

        if (chartOptions.series[0].data.length <= elementsPerChart) {
          childChartCount.push({
            chartOptions: JSON.parse(JSON.stringify(chartOptions)),
            categories: chartOptions.categoryAxis.categories,
            series: chartOptions.series
          });
          break;
        }
      }

      if (childChartCount.length > 0) {
        childChartCount.forEach((chart) => {
          chart.chartOptions.seriesDefaults.visual = (e: SeriesVisualArgs) => {
            const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
            if (colors.includes(e.series.color)) {
              return e.createVisual();
            }

            const benchmarkColor = this.getSeriesColor(e.series.color);
            var left = e.rect.topLeft();
            var right = e.rect.topRight();
            var width = 5;
            var group = new drawing.Group();
            var index = 0;
            for (var x = left.x; x < right.x; x += width) {
              var currentWidth = width;
              if (x + width > right.x) {
                currentWidth = right.x - x;
              }

              var rect = new geometry.Rect([x, left.y], [currentWidth, e.rect.height()])
              var path = drawing.Path.fromRect(rect, { fill: { color: index % 2 == 0 ? benchmarkColor : "#FFFFFF" }, stroke: null });
              group.append(path);
              index = index + 1;
            }

            return group;
          }
        });

        childChartCount.forEach((chart) => {
          chart.chart.element.nativeElement.style.height = `${complianceChartHeight}px !important`;
        });
      }
    }
  }

  getSeriesColor(color: string): string {
    const colors = ["#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"];
    if (colors.includes(color)) {
      return color;
    }

    switch (color) {
      case 'url(#benchmark1)':
        return '#001689'
      case 'url(#benchmark2)':
        return '#40C4FF'
      case 'url(#benchmark3)':
        return '#9744FF'
      case 'url(#benchmark4)':
        return '#BF44B9'
      case 'url(#benchmark5)':
        return '#E57373'
      case 'url(#benchmark6)':
        return '#FFB300'
    }
  }

  breakChartAll() {
    var _this = this;
    if (this.chartOptionsSubstep && this.chartOptionsProcess && this.chartOptionsFrequency &&
      this.chartOptionsComments && this.chartOverallCompliance && this.chartFiveMoments && this.chartAsepticProcedures) {
      var time = 0;
      if (this.isSOP) {
        this.processComplianceChart.chartOptions = this.chartOptionsProcess;
        this.breakChartProcess()
        this.processComplianceChart.chartDatamani();
        time += 5;
        setTimeout(() => {
          _this.frequencyChart.chartOptions = _this.chartOptionsFrequency;
          _this.breakChartComplianceMultiFilter(_this.frequencyChart, _this.processComplianceDetails, _this.childChartCountFrequency, 400, true)
          _this.frequencyChart.chartDatamani();
        }, time)
        time += 5;
        setTimeout(() => {
          _this.subStepProcessChart.chartOptions = _this.chartOptionsSubstep;
          _this.breakChartComplianceMultiFilter(_this.subStepProcessChart, _this.frequencyDistributionDetails, _this.childChartCountSubstep, 400, true)
          _this.subStepProcessChart.chartDatamani();
        }, time)
        time += 5;
        setTimeout(() => {
          _this.predefinedCommentsChart.chartOptions = _this.chartOptionsComments;
          _this.breakChartComplianceMultiFilter(_this.predefinedCommentsChart, _this.subStepComplianceDetails, _this.childChartCountComments, 400, true)
          _this.predefinedCommentsChart.chartDatamani();
        }, time)
      }
      if (this.isObserve) {
        time += 5;
        setTimeout(() => {
          _this.overallCompliance.chartOptions = _this.chartOverallCompliance;
          _this.breakChartComplianceMultiFilter(_this.overallCompliance, _this.commentsDetails, _this.childChartCountOverallCompliance, 400)
          _this.overallCompliance.chartDatamani();
        }, time)
        time += 5;
        setTimeout(() => {
          _this.fiveMoments.chartOptions = _this.chartFiveMoments;
          _this.breakChartComplianceMultiFilter(_this.fiveMoments, _this.overallComplianceDetails, _this.childChartCountFiveMoments, 400)
          _this.fiveMoments.chartDatamani();
        }, time)
        time += 5;
        setTimeout(() => {
          _this.asepticProcedures.chartOptions = _this.chartAsepticProcedures;
          _this.breakChartComplianceMultiFilter(_this.asepticProcedures, _this.fiveMomentsDetails, _this.childChartCountAsepticProcedures, 400)
          _this.asepticProcedures.chartDatamani();
        }, time)
        time += 5;
        setTimeout(() => {
          _this.observeComments.chartOptions = _this.chartObserveComments;
          _this.breakChartComplianceMultiFilter(_this.observeComments, _this.asepticProceduresDetails, _this.childChartCountObserveComments, 700)
          _this.observeComments.chartDatamani();
        }, time)
      }

    }
  }

  checkEvalMode() {
    this.isObserve = (this.roleId == 1 || this.roleId == 2 || this.layoutService.isObserveLicense(this.packageID));
    this.isSOP = (this.roleId == 1 || this.roleId == 2 || this.layoutService.isMyHygieneSOPLicense(this.packageID));
    this.isCheck = (this.roleId == 1 || this.roleId == 2 || this.layoutService.isHygieneCheckLicense(this.packageID));
  }

  private loadLogo(): void {
    this.layoutService.getAppLogoBase64()
      .then((logo) => {
        if (!logo) {
          return;
        }

        this.logoSrc = logo;
      })
      .catch(() => {
        // Keep default asset path fallback if conversion fails
        this.logoSrc = 'assets/img/app-logo.svg';
      });
  }
}
